'use client';

import SheetNavigationHeader from './SheetNavigationHeader';
import { Skeleton } from './Skeleton';

export function SheetHeaderSkeleton() {
  return <SheetNavigationHeader title={<Skeleton height={24} width={180} />} />;
}
